import CommuneIndex from './CommunesIndex';

export default CommuneIndex;
